type PerspectiveConfig = {
  icon: string;
  bgColor: string;
  borderColor: string;
  titleColor: string;
};

export const perspectiveConfigs: Record<"internal" | "external", PerspectiveConfig> = {
  internal: {
    icon: "🔧",
    bgColor: "bg-orange-50 dark:bg-orange-900/20",
    borderColor: "border-orange-200 dark:border-orange-800",
    titleColor: "text-orange-900 dark:text-orange-300",
  },
  external: {
    icon: "🎉",
    bgColor: "bg-green-50 dark:bg-green-900/20",
    borderColor: "border-green-200 dark:border-green-800",
    titleColor: "text-green-900 dark:text-green-300",
  },
};

export function getInsightTypeColor(type: string): string {
  switch (type) {
    case "positive":
      return "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 border-green-300 dark:border-green-700";
    case "negative":
      return "bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 border-red-300 dark:border-red-700";
    case "actionable":
      return "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 border-blue-300 dark:border-blue-700";
    case "neutral":
    default:
      return "bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 border-gray-300 dark:border-gray-600";
  }
}

export function getPriorityIcon(priority: number): string {
  if (priority === 1) return "🔴";
  if (priority === 2) return "🟠";
  if (priority === 3) return "🟡";
  if (priority === 4) return "🟢";
  return "⚪";
}
